/** 各业务共用的订阅套餐分组，业务专属分组由各业务扩展 */
export enum SubscribeCategoryGroupCodeIntl {
    // 订阅默认非会员入口
    PayDefaultVip = 'X_design_Pay',
    // 订阅默认会员入口
    PayDefaultAllVip = 'Xdesign_All_Pay',
    // 通用 Pro 会员入口，商品图、视频翻译、故事书等业务使用
    PayDefaultProVip = 'Xdesign_Pro_Pay',
    // 订阅默认美叶入口
    PayDefaultCredit = 'X_design_PayMy',

    // 商品工具类：商品图、AI模特/试衣/换鞋、AI换色 - 会员入口
    PayECommerce = 'X_design_PayEcommerce',
    // 订阅默认Pro会员 商品工具类：商品图、AI模特/试衣/换鞋、AI换色
    PayECommerceProVip = 'Xdesign_Pro_PayEcommerce',
    // 商品工具类：商品图、AI模特/试衣/换鞋、AI换色 - 美叶入口
    PayECommerceCredit = 'X_design_CreditEcommerce',

    // 订阅会员 视频
    PayVideoVip = 'X_design_PayVideo',
    // 订阅默认Pro会员 视频
    PayVideoProVip = 'Xdesign_Pro_PayVideo',
    // 订阅美叶 视频
    PayVideoCredit = 'X_design_CreditVideo',

    // DesignKit 试用入口
    DK_WEB_Trial = 'DK_WEB_Trial',
    // DesignKit 会员入口
    DK_WEB_Vip = 'DK_WEB_onlyVIP',
    // DesignKit 单 Pro 会员入口
    DK_WEB_ProVip = 'DK_WEB_VIP_Pro',
    // DesignKit 单 Pro 会员入口（无试用）
    DK_WEB_ProVip_NoTrial = 'DK_WEB_VIP_Pro_NoTrial1',
    // DesignKit 美叶入口
    DK_WEB_Credit = 'DK_WEB_onlyCredit',
    // DesignKit 会员升级
    DK_WEB_Upgrade = 'DK_WEB_Upgrade',
    // DesignKit 无试用入口
    DK_WEB_NoTrial = 'DK_WEB_NoTrial',
    // DesignKit 会员升级（无试用）
    DK_WEB_Upgrade_NoTrial = 'DK_WEB_Upgrade_NoTrial',
}
